<div class="app-layout">
  <yt-topbar [isUserAuthenticated]="isAuthenticated()" (sidebarToggle)="toggleSidebar()"></yt-topbar>

  <div class="app-body" [class.sidebar-open]="isAuthenticated() && sidebarOpen()">
    @if (isAuthenticated()) {
      <aside class="sidebar-container" [class.open]="sidebarOpen()">
        <yt-sidebar />
      </aside>
    }

    <div class="content-wrapper">
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>

      <footer class="app-footer">
        <p>
          &copy; {{ currentYear }}
          <img class="footer-logo" src="/assets/logo.svg" alt="" />
          Youtopia. All rights reserved.
        </p>
      </footer>
    </div>
  </div>
</div>

<!-- Global PrimeNG components -->
<p-toast>
  <ng-template #message let-message>
    @switch (message.severity) {
      @case ('success') {
        <span class="p-toast-message-icon pi pi-check"></span>
      }
      @case ('warn') {
        <span class="p-toast-message-icon pi pi-exclamation-triangle"></span>
      }
      @case ('error') {
        <span class="p-toast-message-icon pi pi-times-circle"></span>
      }
      @default {
        <span class="p-toast-message-icon pi pi-info-circle"></span>
      }
    }
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      @if (message.detail) {
        <div class="p-toast-detail">{{ message.detail }}</div>
      }
      @if (message.data?.path) {
        <code class="toast-path" [title]="message.data.path">{{ message.data.path }}</code>
      }
      @if (message.data?.link) {
        <a class="toast-link" data-testid="toast-link" [routerLink]="message.data.link">{{ message.data.linkText }}</a>
      }
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog></p-confirmDialog>
